var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectProjectStage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9447 8.63352C11.7938 8.63352 12.4821 7.90225 12.4821 7.00019C12.4821 6.09812 11.7938 5.36685 10.9447 5.36685C10.0956 5.36685 9.40723 6.09812 9.40723 7.00019C9.40723 7.90225 10.0956 8.63352 10.9447 8.63352Z",
    fill: "#13B76E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4992 5.36667C19.9501 5.36667 19.4376 5.67778 19.1814 6.18333H17.5341C17.1314 2.68333 14.3494 0 10.9817 0C7.61398 0 4.83195 2.68333 4.42929 6.14444H2.85524C2.599 5.67778 2.08652 5.32778 1.53744 5.32778C0.695508 5.32778 0 6.06667 0 6.96111C0 7.85556 0.695508 8.59444 1.53744 8.59444C2.08652 8.59444 2.5624 8.28333 2.85524 7.85556H4.46589C4.86855 11.3167 7.65058 14 10.9817 14C14.3128 14 17.0948 11.3167 17.4975 7.89444H19.1448C19.4376 8.36111 19.9135 8.63333 20.4626 8.63333C21.3045 8.63333 22 7.89444 22 7C22 6.10556 21.3411 5.36667 20.4992 5.36667ZM10.9817 11.6667C8.56573 11.6667 6.58902 9.56667 6.58902 7C6.58902 4.43333 8.56573 2.33333 10.9817 2.33333C13.3977 2.33333 15.3744 4.43333 15.3744 7C15.3744 9.56667 13.3977 11.6667 10.9817 11.6667Z",
    fill: "#13B76E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectProjectStage);
export default __webpack_public_path__ + "static/media/select-project-stage.1d6efa4db6f8475159f7a96b2d391f8d.svg";
export { ForwardRef as ReactComponent };